import { useEffect, useState } from "react";
import { RadioGroup } from "@headlessui/react";
import { t } from "@/i18n-js/instance";
import type { SortOptions } from "@/react/components/shared/MembersList/constants";
import { Button } from "@/react/components/shared/uikit/Button";
import { Loader } from "@/react/components/shared/uikit/Loader";
import { Radio } from "@/react/components/shared/uikit/Radio";
import { Typography } from "@/react/components/shared/uikit/Typography";
import {
  useCommunitySettingShow,
  useUpdateCommunitySetting,
} from "@/react/hooks/UseCommunitySetting";
import { useControlsDropdownContext } from "./context";

const i18nBase = "members_directory.controls_dropdown.sort_selector";

export const SortSelector = () => {
  const { data, isLoading } = useCommunitySettingShow();

  const { setCurrentComponent } = useControlsDropdownContext();
  const updateCommunitySettingMutation = useUpdateCommunitySetting();

  const communitySetting = data?.community_settings;

  const [sort, setSort] = useState<SortOptions>("alphabetical");

  useEffect(() => {
    const currentSort = communitySetting?.member_directory_settings?.sort;
    if (currentSort) {
      setSort(currentSort);
    }
  }, [communitySetting]);

  const handleSave = () => {
    updateCommunitySettingMutation.mutate(
      {
        data,
        updates: {
          member_directory_settings: {
            ...communitySetting?.member_directory_settings,
            sort,
          },
        },
      },
      {
        onSuccess: () => {
          setCurrentComponent("root");
        },
      },
    );
  };

  const handleCancel = () => {
    setSort(communitySetting?.member_directory_settings?.sort as SortOptions);
    setCurrentComponent("root");
  };
  return (
    <div className="flex flex-col gap-3 p-3">
      <Typography.LabelMd weight="semibold">
        {t(`${i18nBase}.title`)}
      </Typography.LabelMd>
      {isLoading ? (
        <div className="flex items-center justify-center">
          <Loader />
        </div>
      ) : (
        <div className="mt-2">
          <RadioGroup value={sort} onChange={setSort}>
            <RadioGroup.Option value="alphabetical">
              {({ checked }) => (
                <Radio
                  id="sort-alphabetical"
                  name="sort"
                  label={t(`${i18nBase}.alphabetical`)}
                  checked={checked}
                />
              )}
            </RadioGroup.Option>
            <RadioGroup.Option value="latest">
              {({ checked }) => (
                <Radio
                  id="sort-latest"
                  name="sort"
                  label={t(`${i18nBase}.latest`)}
                  checked={checked}
                />
              )}
            </RadioGroup.Option>
            <RadioGroup.Option value="oldest">
              {({ checked }) => (
                <Radio
                  id="sort-oldest"
                  name="sort"
                  label={t(`${i18nBase}.oldest`)}
                  checked={checked}
                />
              )}
            </RadioGroup.Option>
          </RadioGroup>
        </div>
      )}

      <div className="mt-3 flex justify-end gap-2">
        <Button variant="secondary" onClick={handleCancel}>
          {t(`${i18nBase}.cancel`)}
        </Button>
        <Button
          variant="primary"
          onClick={handleSave}
          disabled={updateCommunitySettingMutation.isLoading}
        >
          {t(`${i18nBase}.save`)}
        </Button>
      </div>
    </div>
  );
};
